module.exports = __webpack_public_path__ + "static/media/icon-eye-close.afdf5d2a.svg";